import { Component } from '@angular/core';

@Component({
  selector: 'app-ol',
  templateUrl: './optional-label.component.html',
  styleUrls: ['./optional-label.component.scss']
})
export class OptionalLabelComponent {

}
